import React from "react";
import { IntlShape } from "react-intl";
import Paginate from "../../Paginate";
import { LIMIT_OPTIONS } from "../../../utils/config";

interface FootProps {
  total: number;
  limit: number;
  limitChoiceEnabled?: boolean;
  onPageChange: (page: number) => void;
  onLimitChange?: (limit: number) => void;
  forcePage: number;
  intl: IntlShape;
  className?: string;
}

interface LimitSelectorProps {
  limit: number;
  onLimitChange: (limit: number) => void;
  intl: IntlShape;
}

const LimitSelector: React.FC<LimitSelectorProps> = ({
  limit,
  onLimitChange,
  intl,
}) => (
  <div className="ml-auto flex items-center space-x-2">
    <label htmlFor="limitOptions" className="text-sm font-medium">
      {intl.formatMessage({ id: "general.items.per.page" })}
    </label>
    <select
      id="limitOptions"
      name="limitOptions"
      aria-label={intl.formatMessage({ id: "general.items.per.page" })}
      className="outline-none border border-gray-300 rounded-md px-2 py-1 text-sm"
      value={limit}
      onChange={e => onLimitChange(Number(e.target.value))}
    >
      {LIMIT_OPTIONS.map(option => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  </div>
);

const Foot: React.FC<FootProps> = ({
  total,
  limit,
  limitChoiceEnabled = false,
  onPageChange,
  onLimitChange,
  forcePage,
  intl,
  className,
}) => {
  const canPaginate = total > limit;

  return (
    <div className={`px-8 ${className || "p-5"}`}>
      <div className="flex w-full h-full items-center relative">
        {canPaginate && (
          <div className="flex flex-1 justify-center">
            <Paginate
              total={total}
              limit={limit}
              onPageChange={onPageChange}
              forcePage={forcePage}
            />
          </div>
        )}

        {limitChoiceEnabled && onLimitChange && (
          <LimitSelector
            limit={limit}
            onLimitChange={onLimitChange}
            intl={intl}
          />
        )}
      </div>
    </div>
  );
};

export default Foot;
